import { render } from "./ExcelComponent.vue?vue&type=template&id=379eb2e8"
import script from "./ExcelComponent.vue?vue&type=script&lang=js"
export * from "./ExcelComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__